// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_LOCATION = 'UPDATE_LOCATION';

// ------------------------------------
// Actions
// ------------------------------------
export function setLocation(value) {
  return ({
    type: UPDATE_LOCATION,
    payload: value
  });
}



// WEBPACK FOOTER //
// ./src/redux/actions/windowLocation.js